// extracted by mini-css-extract-plugin
module.exports = {"filter":"_fe34acb","text":"_7535b1d","label":"_415ae38"};